var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletInfra(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 540,
    height: 188,
    viewBox: "0 0 540 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2236_8545)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2236_8545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H524C532.837 0 540 7.16344 540 16V172C540 180.837 532.837 188 524 188H16C7.16345 188 0 180.837 0 172V16Z",
    fill: "#5DE2F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.068 167.689L350.881 167.689L350.881 23.3114L560.068 23.3114L560.068 167.689Z",
    fill: "#EEF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.0678 23.3114L199.119 23.3114L199.119 167.689L-10.0678 167.689L-10.0678 23.3114Z",
    fill: "#EEF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.715 82.3016H284.556C287.741 82.3016 290.316 84.8637 290.316 88.032V102.799C290.316 105.967 287.741 108.529 284.556 108.529H269.715C266.531 108.529 263.956 105.967 263.956 102.799V88.032C263.928 84.8913 266.503 82.3016 269.715 82.3016Z",
    fill: "#0A0B0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.522 24.44V167.89H161.336V24.44H391.522Z",
    fill: "#0052FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.975 58.5094H391.522V133.821H333.975V58.5094Z",
    fill: "#0A0B0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.522 58.5094H405.909V133.821H391.522V58.5094Z",
    fill: "#0052FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.135 10.095H177.423C169.092 10.095 162.231 16.371 161.336 24.44H377.135V10.095Z",
    fill: "#0A0B0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.749 85.4063L373.539 96.165L362.749 106.924L351.959 96.165L362.749 85.4063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.37 58.5903C113.449 58.5903 103.792 68.2242 103.792 80.11C103.792 68.2242 94.1301 58.5903 82.2098 58.5903C94.1301 58.5903 103.792 48.9565 103.792 37.075C103.792 48.9565 113.449 58.5903 125.37 58.5903Z",
    fill: "#5DE2F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.228 153.544C484.281 153.544 477.843 159.966 477.843 167.89C477.843 159.966 471.402 153.544 463.455 153.544C471.402 153.544 477.843 147.121 477.843 139.2C477.843 147.121 484.281 153.544 492.228 153.544Z",
    fill: "#5DE2F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.79 79.7972L103.79 37.3875C103.791 37.2835 103.792 37.1793 103.792 37.075C103.792 48.9565 113.449 58.5903 125.37 58.5903C113.449 58.5903 103.792 68.2242 103.792 80.11C103.792 80.0056 103.791 79.9013 103.79 79.7972Z",
    fill: "#0052FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2236_8545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 540,
    height: 188,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2236_8545"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H524C532.837 0 540 7.16344 540 16V172C540 180.837 532.837 188 524 188H16C7.16345 188 0 180.837 0 172V16Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletInfra);
export default __webpack_public_path__ + "static/media/Wallet-Infra.b1cae195ec03e40eb1e9d4d1b7193805.svg";
export { ForwardRef as ReactComponent };